import React, { useContext, useEffect, useState, useRef } from 'react'
import { TypeCartePrepayee } from 'types/carteprepayee'
import classNames from 'classnames'
import CartePrepayeeContext from 'contexts/catrePrepayeeContext'
import { useNavigate } from 'react-router-dom'
import UserContext from 'contexts/UserContext'
import ModalTestStatusUser from 'components/modalTestStatusUser'

interface Props {
  products: TypeCartePrepayee[]
  handdleSelect: (item: TypeCartePrepayee, index: number) => void
  onBackChangeStep: () => void
  indexCarte: number
  onChangeStep: () => void
  operateur: string
  logoOperateur:string
}

const MontantPrepayee: React.FC<Props> = ({
  products,
  handdleSelect,
  onBackChangeStep,
  indexCarte,
  onChangeStep,
  operateur,
  logoOperateur
}) => {
  const { carte } = useContext(CartePrepayeeContext)
  const { user } = useContext(UserContext)
  const navigate = useNavigate()
  const statusComplete = user?.user?.status === 'confirmed' && user?.user?.isDocumentSent
  const statusPending = user?.user?.status === 'pending' && user?.user?.isDocumentSent
  const statusNotFound = user?.user?.status === 'pending' && !user?.user?.isDocumentSent
  const [openIsModalStatus, setOpenIsModalStatus] = useState(false)

  const [maxHeight, setMaxHeight] = useState(window.innerHeight * 0.7)
  const containerRef = useRef<HTMLDivElement>(null)
  const cartesTriees = products.sort((a, b) => b.receiveValue - a.receiveValue)

  const openModalStatus = () => setOpenIsModalStatus(true)
  const closeModalStatus = () => setOpenIsModalStatus(false)

  // Ajuster la hauteur du div scrollable selon l'écran
  useEffect(() => {
    const handleResize = () => setMaxHeight(window.innerHeight * 0.7)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div className="flex flex-col w-full items-center justify-center">
      <div
        ref={containerRef}
        style={{ maxHeight }}
        className=" flex flex-wrap justify-center pb-[120px] lg:pb-[50px] xl:px-[5px] sm:px-3 gap-6 sm:gap-3 items-center w-full pt-[30px] overflow-y-auto scrollbar-webkit"
      >
        {cartesTriees.map((carte: TypeCartePrepayee, index: number) => (
          <div
            key={index}
            onClick={() => handdleSelect(carte, index)}
            className={classNames(
              'w-[320px] 3xl:w-[280px] sm:w-full cursor-pointer rounded-[20px] h-[130px] flex flex-col px-[30px] sm:px-[20px] py-[12px]',
              indexCarte !== -1
                ? indexCarte === index
                  ? 'bg-[#E2E2FB] ring-2 ring-offset-4 ring-[#5754E5] text-[#35258B]'
                  : 'bg-[#EEEEEE] opacity-60 text-[#767676]'
                : 'bg-[#EEEEEE] text-[#767676]'
            )}
          >
            <div className="flex items-start justify-between">
              <div className="flex -mt-2 text-[42px] font-extrabold font-roboto">
                {carte.receiveValue} <span className="text-[22px]">€</span>
              </div>
              <img
              src={logoOperateur}
                // src={operateur === 'OHFR' ? logoPCS : logoTranscash}
                width={operateur === 'OHFR' ? 80 : 103}
                height={38}
                alt="logo carte Recharge prépayée "
              />
            </div>

            <div className="flex justify-between items-start">
              <div className="flex flex-col">
                <span className="text-[10px]">Montant à recevoir</span>
                <span className="text-[12px] font-bold">{carte.receiveValue} €</span>
              </div>
              <div className="flex flex-col items-end">
                <div className="text-[10px]">Montant à payer</div>
                <div className="text-[12px] font-bold">{carte.totalWithFee} €</div>
                <div
                  className={classNames(
                    'text-white px-1 font-medium text-[10px]',
                    indexCarte !== -1
                      ? indexCarte === index
                        ? 'bg-[#35258B]'
                        : 'bg-[#767676]'
                      : 'bg-[#767676]'
                  )}
                >
                  Inclus {carte.fees} € de frais
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Boutons fixes en bas */}
      <div  className=" flex justify-center pt-[30px] pb-[120px] lg:pb-[50px]  gap-6 sm:gap-3 items-center ">
        {/* className=" flex flex-wrap justify-center  pb-[120px] lg:pb-[50px] gap-6 sm:gap-3 items-center w-full pt-[30px] px-2 overflow-y-auto scrollbar-webkit" */}

        <button
          className="text-[#5754E5] h-[56px] w-[140px] border bg-white border-[#5754E5] rounded-[16px]"
          onClick={onBackChangeStep}
        >
          Précédent
        </button>

        <button
          className={classNames(
            'text-[#FFF] w-[357px] h-[56px] rounded-[16px] sm:w-[180px]',
            indexCarte === -1 ? 'bg-[#D1D1FF] cursor-not-allowed' : 'bg-[#5754E5]'
          )}
          onClick={() => {
            if (statusComplete) onChangeStep()
            else if (statusPending) openModalStatus()
            else navigate('/personalinformation')
          }}
          disabled={carte === null}
        >
          Suivant
        </button>
      </div>

      <ModalTestStatusUser
        isOpen={openIsModalStatus}
        closeModal={closeModalStatus}
        statusPending={statusPending}
        statusNotFound={statusNotFound}
      />
    </div>
  )
}

export default MontantPrepayee